import { IDropItem } from "components/inputs/dropdown";
import TextDropdown from "components/inputs/text-dropdown";
import TextInput from "components/inputs/text-input";
import ModalTemplate from "components/modal/modal-template";
import Typography from "components/typography";
import React, { useEffect, useState } from "react";
import { FindArtisByName, GetUserArtists } from "services/user/getUser";
import styled from "styled-components";
import { ITrackSplit } from "types/musicData";
import { Colors } from "utils/colors";
import { IsAnEmail } from "utils/isAnEmail";

interface IProps {
  split?: ITrackSplit[];
  confirm: (name: string, email: string) => void;
  close: () => void;
}
const AddPersonModal = ({ close, confirm, split }: IProps) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  const Artists = () => {
    let temp = GetUserArtists();
    let data: (string | IDropItem)[] = ["None"];
    for (let i = 0; i < temp.length; i++) {
      const name = temp[i].name;
      const FoundName = split?.find(
        (item) =>
          item?.recipientName?.trim().toLowerCase() ===
          name.trim().toLowerCase()
      );

      if (FoundName) {
      } else {
        data.push({
          label: name,
          icon: (
            <ArtistIcon>
              <Typography size="s" color={Colors.white200}>
                {name[0]}
              </Typography>
            </ArtistIcon>
          )
        });
      }
    }
    return data;
  };

  return (
    <ModalTemplate
      confirm={() => {
        confirm(name, email);
        close();
        setEmail("");
        setName("");
      }}
      header="Add Person"
      confirmText="Add Person"
      close={close}
      disableConfirm={name.length === 0 || !IsAnEmail(email)}
    >
      <Container>
        <TextDropdown
          placeholder="Enter Person’s  Name"
          label="Name"
          required
          value={name}
          onChange={(e) => setName(e.target.value)}
          selectItem={(value) => {
            setName(value);
            setEmail(FindArtisByName(value)?.email || "");
          }}
          items={Artists()}
          listCheck={false}
        />

        <Spacer />
        <TextInput
          placeholder="example@gmail.com"
          label="Email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </Container>
    </ModalTemplate>
  );
};

export default AddPersonModal;

const Container = styled.div`
  @media only screen and (max-width: 769px) {
    width: 40rem;
  }
`;

const Spacer = styled.div`
  height: 4rem;
`;

const ArtistIcon = styled.div`
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${Colors.purple200};
`;
